export default __webpack_public_path__ + "static/media/cooperation-img-3.30621549.png";